import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "market-card" }
const _hoisted_2 = { class: "market-header" }
const _hoisted_3 = { class: "market-status" }
const _hoisted_4 = { class: "status" }

import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios'

type SignalType = 'red' | 'yellow' | 'green' | 'loading'

interface SignalResponse {
  market: string
  timeframe: string
  signal: SignalType
  timestamp: string
  metadata: {
    volatility: number | null
    trend: string | null
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketSignal',
  props: {
    marketId: {},
    name: {}
  },
  setup(__props: any) {

const props = __props

const signal = ref<SignalType>('loading')

const getStatusText = (signal: string) => {
  const statusMap: { [key: string]: string } = {
    'red': '高波动',
    'yellow': '中等波动',
    'green': '低波动',
    'loading': '计算中'
  }
  return statusMap[signal] || '未知状态'
}

const fetchSignal = async () => {
  try {
    const response = await axios.get<SignalResponse>(`/api/signal?market=${props.marketId}`)
    signal.value = response.data.signal
  } catch (error) {
    console.error(`获取${props.marketId}市场信号失败:`, error)
  }
}

let timer: number

onMounted(() => {
  fetchSignal()
  timer = window.setInterval(fetchSignal, 60000)
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["signal-dot", signal.value])
        }, null, 2),
        _createElementVNode("span", _hoisted_4, _toDisplayString(getStatusText(signal.value)), 1)
      ])
    ])
  ]))
}
}

})